import { render, staticRenderFns } from "./merchant_form.vue?vue&type=template&id=493fb0e0&scoped=true"
import script from "./merchant_form.vue?vue&type=script&lang=js"
export * from "./merchant_form.vue?vue&type=script&lang=js"
import style0 from "./merchant_form.vue?vue&type=style&index=0&id=493fb0e0&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fb0e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493fb0e0')) {
      api.createRecord('493fb0e0', component.options)
    } else {
      api.reload('493fb0e0', component.options)
    }
    module.hot.accept("./merchant_form.vue?vue&type=template&id=493fb0e0&scoped=true", function () {
      api.rerender('493fb0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/merchant_form.vue"
export default component.exports